export default __webpack_public_path__ + "static/media/biking.fe885ecd.svg";